import { ScreenType } from '@/helpers/enums';

export const CARD_HEIGHT: Record<ScreenType, number> = {
  [ScreenType.BASE]: 161,
  [ScreenType.SM]: 161,
  [ScreenType.MD]: 180,
  [ScreenType.LG]: 180,
  [ScreenType.XL]: 180,
  [ScreenType.XXL]: 180,
};

export const BALANCE_HEIGHT: Record<ScreenType, number> = {
  [ScreenType.BASE]: 43,
  [ScreenType.SM]: 43,
  [ScreenType.MD]: 48,
  [ScreenType.LG]: 48,
  [ScreenType.XL]: 48,
  [ScreenType.XXL]: 48,
};
